import { AuthenticationErrorScreen } from 'components/screens';

export const AuthenticationErrorPage = () => <AuthenticationErrorScreen />;
